<script setup>
import { ref } from "vue";

const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const formModel = ref({});

const handleShow = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formModel.value = Object.assign({});
};

defineExpose({
  handleShow,
  title,
});
</script>

<template>
  <a-modal
    width="1200px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
  >
    <a-descriptions
      style="padding-top: 10px"
      title=""
      bordered
      size="small"
      :labelStyle="{
        width: 'fit-content',
        wordBreak: 'keep-all',
      }"
    >
      <a-descriptions-item label="职位标题">
        {{ formModel.title }}
      </a-descriptions-item>
      <a-descriptions-item label="职位名称">
        {{ formModel.name }}
      </a-descriptions-item>
      <a-descriptions-item label="工种名称">
        {{ formModel.jobTypeName }}
      </a-descriptions-item>
      <a-descriptions-item label="职位类型">
        <template v-if="formModel.workingType === 'FULL'"> 全职</template>
        <template v-else-if="formModel.workingType === 'PART'"> 兼职</template>
        <template v-else>{{ formModel.workingType }}</template>
      </a-descriptions-item>
      <a-descriptions-item label="薪资">
        <template
          v-if="!formModel['wageUnit'] || formModel['wageUnit'] === '面议'"
        >
          薪资面议
        </template>
        <template v-else>
          {{ formModel["minWage"] }}-{{ formModel["maxWage"]
          }}{{ formModel["wageUnit"] }}
        </template>
      </a-descriptions-item>
      <a-descriptions-item label="招聘人数">
        {{ formModel.headcount }}
      </a-descriptions-item>
      <a-descriptions-item label="发布时间">
        {{ formModel.postingTime }}
      </a-descriptions-item>
      <a-descriptions-item label="发布人">
        {{ formModel.recruiterRealName }}
      </a-descriptions-item>
      <a-descriptions-item label="所属企业">
        {{ formModel.companyName }}
      </a-descriptions-item>
      <a-descriptions-item label="地址" :span="3">
        <div>
          {{ formModel.provinceName }}{{ formModel.cityName
          }}{{ formModel.districtName }}
        </div>
        <div>{{ formModel.address }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="职位介绍" :span="3">
        {{ formModel.description }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>

<style scoped lang="scss"></style>
